export default __webpack_public_path__ + "static/media/infoStep.234414e2.png";